<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						{{ config.type === "이동" ? "이동" : "복사 "}}
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-10 clearfix" style="max-height: 300px;background-color: #f8f8f8;">
					<table class="table2 table-condensed table-hover m-t-10 text-center">
						<tbody v-for="(board) in boardList" :key="`board-${hash(board)}`">
							<tr :class="selectedBoardId === board.board.boardId ? 'on' : ''" @click="selectedBoard(board.board)">
								<td class="text-left" >
									{{board.name}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer p-15 m-t-5 clearfix">
					<button class="btn bg-deepblue half-width text-white round pull-left" @click="onExecute">실행</button>
					<button class="btn half-width round pull-right" @click="config.show=false">취소</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Axios from 'axios';
import server from '../statics/server.js'

export default {
	name: "ModalBoardManager",
	default: function() {
		return {
			name: this.name,
			type: "복사",
			show: false,
		}
	},
	mounted: function() {
	},
	data: function() {
		return {
			selectedBoardId: ""
		}
	},
	methods: {
		selectedBoard: function(board){
			this.selectedBoardId = board.boardId
		},
		onExecute: function() {
			this.$emit("onConfirm", {
				message: (this.config.type === "이동" ? "이동" : "복사 ") + " 하시겠습니까?",
				yesCb: async () => {
					try {

						const boardId = this.selectedBoardId;
						const articleId = this.config.article.articleId; 

						let article = this.config.article; 

						if(this.config.type === "이동"){
							
							await Axios.patch(server.addr()+server.api.ARTICLE+"/"+articleId, {
								boardId : boardId
							}).then( () => {
								this.$emit("onDone", (this.config.type === "이동" ? "이동" : "복사 ") + " 되었습니다.");
								this.$router.go();
							})

						}else{

							article.boardId = boardId;
							// article.noticeEnable = this.config.article.noticeEnable === true ? 1 : 0;

							await Axios.put(`${server.addr()}${server.api.ARTICLE}`, [article]).then( () => {
								this.$emit("onDone", (this.config.type === "이동" ? "이동" : "복사 ") + " 되었습니다.");
								this.$router.go();
							})
							
						}
							
					} catch(e) {
						// TODO: 서버쪽 오류랑 매핑시킬 것!
						this.$emit("onDone", "서버 오류");
					}
				}
			})
		}
	},
	props: {
		config: Object,
		boardList : Array
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>